import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import DallasTextSkeleton from '~/app/_ui/Dallas/Text/DallasTextSkeleton';
import DallasSkeleton from '~/app/_ui/Dallas/Skeleton/DallasSkeleton';

import styles from './BrokerSkeletonCell.module.scss';

type Props = {
  className?: string;
};
export default function BrokerAndPickupSkeletonCell({ className }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasSkeleton className={styles.brokerLogo} variant="semi-rounded" />
      <DallasTextSkeleton variant="captionL" fullLine />
    </DallasTableDataCell>
  );
}
